var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 360,
    fill: "#EDE8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.1 148.497C197.1 151.851 199.844 154.495 203.324 154.495C206.804 154.495 209.548 151.851 209.548 148.497C209.548 145.144 206.804 142.5 203.324 142.5C199.844 142.5 197.1 145.144 197.1 148.497ZM142.554 148.497C142.554 151.851 145.298 154.495 148.779 154.495C152.259 154.495 155.003 151.851 155.003 148.497C155.003 145.144 152.259 142.5 148.779 142.5C145.298 142.5 142.554 145.144 142.554 148.497Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120 199.637C136.062 211.825 156.475 217.5 180.033 217.5C203.525 217.5 223.871 211.825 240 199.637L240 192.221C227.485 202.087 202.253 208.794 180.033 208.794C157.814 208.794 132.515 202.087 120 192.221L120 199.637Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.bdd2fa230b5c7342ca6d5a6c6ea372fa.svg";
export { ForwardRef as ReactComponent };